module.exports = "img/flags/VA.345a700.png";